import React from 'react';
import { Configs } from 'Constants';

export type StepType = 'PAST' | 'PRESENT' | 'FUTUR';

interface Props {
  stepNumber: number;
  stepName: string;
  type: StepType;
}

const bubbleColors: Record<StepType, string> = {
  PAST: 'border-navy-blue bg-navy-blue text-white',
  PRESENT: 'border-navy-blue bg-white text-navy-blue',
  FUTUR: 'border-light-silver bg-whitesmoke text-sonic-silver',
};
const labelColors: Record<StepType, string> = {
  PAST: 'text-black',
  PRESENT: 'text-navy-blue',
  FUTUR: 'text-sonic-silver',
};

export const PipeStep: React.FC<Props> = ({ stepNumber, stepName, type }) => {
  const redirectToCart = () => {
    window.location.href = `${Configs.basketUrl}`;
  };

  return (
    <div className={`${stepNumber === 1 && 'cursor-pointer'} flex flex-col items-center font-semibold`} onClick={redirectToCart}>
      <span className={`rounded-full border-2 text-sm h-8 w-8 flex items-center justify-center ${bubbleColors[type]}`}>{stepNumber}</span>
      <span
        className={`font-normal md:text-xs text-[10px] absolute mt-10 w-[55px] md:w-fit md:fit-content flex justify-center text-center ${labelColors[type]}`}
      >
        {stepName}
      </span>
    </div>
  );
};
